<template>
    <div>
        <div class="mark arrow2 borderBotLeft0 col666" @click="onPopup">
            <img class="serveImg" src="../../../../../assets/img/b2b/icon_zheng@2x.png" alt="">正品保障&店铺售后<div class="item"></div>
        </div>
        <ServerPopup :visible.sync='serverPopup' />
    </div>
</template>

<script>
import ServerPopup from './serverPopup'
export default {
    components: {
        ServerPopup
    },
    props: {
        couponsList: {
            type: Array,
            defalut: []
        }
    },
    data () {
        return {
            serverPopup: false,
            userInfo: {}
        }
    },
    methods: {
        onPopup () {
            this.serverPopup = !this.serverPopup
        }
    }
}
</script>

<style lang="scss" scoped>
    .mark {
        font-size: 28px;
        position: relative;
        background-color: #ffffff;
        height: 96px;
        line-height: 96px;
        padding: 0 32px;
        .serveImg {
            width: 32px;
            height: 32px;
            vertical-align: sub;
            padding-right: 12px;
        }
    }
</style>